import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Dialog, DialogContent, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OtpInput from '../components/OtpInput';
import apiService from '../components/ReasuableFuncations/api';

const VerifyCodePage = () => {
  const [open, setOpen] = useState(true);
  const [error, setError] = useState(null);
  const [autoFilledOtp, setAutoFilledOtp] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check for auto-fill OTP from localStorage
    const storedOtp = localStorage.getItem("autoFillOtp");
    if (storedOtp) {
      setAutoFilledOtp(storedOtp);
      // Auto-verify after a short delay to allow UI to render
      setTimeout(() => {
        handleVerify(storedOtp);
      }, 1000);
      // Clean up the stored OTP
      localStorage.removeItem("autoFillOtp");
    }
  }, []);

  const handleVerify = async (otp) => {
    setError(null);

    if (!otp || otp.length !== 6) {
      setError('Please enter a valid 6-digit code');
      return;
    }
    
    const contactInfo = localStorage.getItem('contactInfo');
    if (!contactInfo) {
      setError('Email or mobile number not found. Please try signing in again.');
      return;
    }

    try {
      const response = await apiService.post('/api/verifyOtp', { 
          contactInfo: contactInfo,
          otp: otp.toString()},
      );
      const data = response.data;
      if (response.statusText === 'OK') {
        const { accessToken, userData } = data;
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.removeItem('contactInfo', contactInfo)
        const expirationTime = new Date().getTime() + (3600 * 1000);
        localStorage.setItem('tokenExpiration', expirationTime.toString());
        setTimeout(() => navigate('/home'), 1000);
        setOpen(false);
        navigate('/home');
      } else {
        throw new Error(data.message || 'Verification failed');
      }
    } catch (error) {
      console.error('Verification error:', error);
      setError(error.message || 'An unexpected error occurred');
    }
  };

  const handleClose = () => {
    setOpen(false);
    navigate('/login'); 
  };

  const handleButtonClick = () => {
    const inputs = Array.from(document.querySelectorAll('input[type="text"]'));
    const otpValue = inputs.map(input => input.value).join('');
    handleVerify(otpValue);
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      disableEscapeKeyDown 
      disableBackdropClick 
    >
      <DialogContent>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          padding: '20px', 
          borderRadius: '12px',
          gap: '16px'
        }}>
          <Typography variant="h4">Enter Code</Typography>
          
          {error && (
            <Alert severity="error" sx={{ width: '100%' }}>
              {error}
            </Alert>
          )}

          {autoFilledOtp && (
            <Alert severity="info" sx={{ width: '100%' }}>
              OTP auto-filled! Verifying...
            </Alert>
          )}

          <OtpInput 
            length={6} 
            onComplete={handleVerify} 
            autoFillValue={autoFilledOtp}
          />
          
          <Typography 
            variant="body2" 
            color="textSecondary" 
            sx={{ textAlign: 'center' }}
          >
            Please enter the 6-digit one-time password (OTP) sent to your registered email or phone number.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: '8px', padding: '10px' }}
            onClick={handleButtonClick} 
          >
            Verify
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VerifyCodePage;